<button>
  <span>
    <ng-content></ng-content>
  </span>

  <opac-badge *ngIf="count > 0">{{ count }}</opac-badge>
</button>
